import { restClient } from '@/Core'

/** Групове копіювання в папку (копія посилається на той самий вміст): `POST /services/disk/nodes/copy`. */
export const CopyDiskNodesTask = async (nodes: string[], target: string): Promise<void> => {
    await restClient.post('/services/disk/nodes/copy', { json: { nodes, target } })
}
